var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.07143 4.10714C5.97281 4.10714 5.89286 4.02719 5.89286 3.92857V0H4.10714V3.92857C4.10714 4.02719 4.02719 4.10714 3.92857 4.10714H0V5.89286H3.92857C4.02719 5.89286 4.10714 5.97281 4.10714 6.07143V10H5.89286V6.07143C5.89286 5.97281 5.97281 5.89286 6.07143 5.89286H10V4.10714H6.07143Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.00560db39730b118717524c636d5b957.svg";
export { ForwardRef as ReactComponent };